<script setup>
import { ref, onMounted } from "vue"
import RelatedService from "./services/RelatedService.js"
import Event from "./components/Event.vue"
import Loader from "./components/Loader.vue"

const items = ref([])
const loading = ref(false)
const title = ref('Related')
const postID = document.querySelector("#related").dataset.id
const rel = document.querySelector("#related").dataset.rel
let baseUrl

onMounted(async () => {

	if( document.querySelector("#related").dataset.title ){
		title.value = document.querySelector("#related").dataset.title
	}

	loading.value = true

	const settings = await getSettings()

	baseUrl = settings.whatson_page_url

	items.value = await getItems()
})

async function getSettings() {

	try {
		const response = await RelatedService.getSettings()
		return response.data

	} catch (error) {
		console.log(error)
	}

}

async function getItems() {

	try {
		const response = await RelatedService.getRelated({
			params: {
				p: postID,
				rel: rel
			}
		})
		loading.value = false
		return response.data.items

	} catch (error) {
		console.log(error)
	}

}

</script>

<template>
	<section class="py-12" v-if="!loading && items">
		<div class="container relative">
			<div class="min-h-[680px]">
				<div class="max-w-3xl text-base mb-8">
					<h2 class="text-lg font-bold font-serif text-pink">{{ title }}</h2>
				</div>
				<div class="grid md:grid-cols-3 gap-8 md:gap-4">
					<TransitionGroup>
						<Event v-for="(item, index) in items"
							:item="item"
							:key="item.id" 
							:base-url="baseUrl"
							/>
					</TransitionGroup>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
	transition: opacity 0.33s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>